// material-ui

import flatbedtruck from '../../../assets/images/Truck/flatbed-truck.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const FlatbedTruck = (props) => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={flatbedtruck} alt="Flatbed" height={props.height || 30}  />
    );
};

export default FlatbedTruck;